import { Component, Input, OnInit } from '@angular/core';
import { ContentService } from '@blk/cwp-ng-framework';
import { DialogRef, DialogService } from '@ddt-web/dialog';
import * as isEmpty from 'lodash/isEmpty';
import { filter, first } from 'rxjs/operators';

import { TourDialogContent } from '../../config';
import { TourDialogService } from '../../services';
import { TourDialogComponent } from '../tour-dialog';
import { TOUR_BANNER_TYPE_OPTION, TourBannerType } from './banner-type-enum.config';

@Component({
	selector: 'ac-tour-banner',
	templateUrl: './tour-banner.component.html',
	styleUrls: ['./tour-banner.component.scss']
})
export class TourBannerComponent implements OnInit {

	@Input() public dialogLocation: string;
	@Input() public bannerType: TourBannerType = TourBannerType.NEW_FEATURE;
	@Input() public isClickable: boolean = true;
	@Input() public bannerMarginTopBottom: Number[] = [55, 40];

	public showQuickTourBanner: boolean = false;
	public featureName: string = '';
	public tourDialogContent: TourDialogContent[];
	public headerColor: string;
	public contentColor: string;
	public iconType: string;
	public bannerMarginClass: string;
	private featureKey: string;

	constructor(
		private tourDialogService: TourDialogService,
		private dialogService: DialogService,
		private contentService: ContentService
	) { }

	public ngOnInit(): void {
		// Updates the feature-name for which the banner content in populated
		this.featureName = this.contentService.get(`TOURDIALOG_${this.dialogLocation}_FEATURENAME`, '').trim();
		this.featureKey = this.dialogLocation && this.featureName ? `TOURDIALOG_${this.dialogLocation}_${this.featureName}` : '';

		// Need to populate the data on component load as there might be a case wherein we have the featureName DCR but other DCRs are absent
		this.tourDialogContent = this.tourDialogService.getTourDialogContent(this.featureName, this.dialogLocation);

		// TourModal will only be shown if it's enabled via contentService or the tourModal has never been launched
		if (this.featureName && this.dialogLocation && localStorage.getItem(this.featureKey) !== 'disabled') {
			this.isClickable = this.isClickable && !isEmpty(this.tourDialogContent);
			localStorage.setItem(this.featureKey, 'enabled');
			this.showQuickTourBanner = true;
		}
		const bannerOption = TOUR_BANNER_TYPE_OPTION[this.bannerType];
		[this.iconType, this.headerColor, this.contentColor] = [bannerOption.icon, bannerOption.headerColor, bannerOption.contentColor];
		this.bannerMarginClass = `margin-top-${this.bannerMarginTopBottom[0]} margin-bottom-${this.bannerMarginTopBottom[1]}`;
	}

	/**
	 * calls getContent to prepare the data for Tour Modal
	 * opens the Tour Modal via dialog-service
	 * After the modal is closed, the banner will no longer be visible if the banner should be disabled
	 */
	public openTourModal(): void {
		let tourModalDialogServiceRef: DialogRef;
		if (this.tourDialogContent?.length && this.showQuickTourBanner) {
			tourModalDialogServiceRef = this.dialogService.open(TourDialogComponent, {
				data: {
					featureName: this.featureName,
					tourDialogContent: this.tourDialogContent
				}
			});

			tourModalDialogServiceRef.afterClosed.pipe(
				first(),
				filter((shouldDisableBanner: boolean) => this.featureKey && shouldDisableBanner)
			).subscribe(() => {
				this.closeTourModal();
			});
		}
	}

	public closeTourModal(): void {
		localStorage.setItem(this.featureKey, 'disabled');
		this.showQuickTourBanner = false;
	}

}
